import * as styles from "./SectionSearchSite.module.scss";

import { navigate } from "gatsby";
import React, { useMemo, useState } from "react";
import { TextInput } from "../../../components/common";
import { Search } from "../../../components/common/Icons";
import sniffingDogImage from "../../../static/img/icon-sniffing-dog.png";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionSearchSiteProps {
	heading: string;
	isHomepage?: boolean;
	jumpLinksTitle?: string;
}

export const getSectionSearchSiteProps = ({
	field_front_end_title,
	field_jump_links_title,
}: Queries.SectionDataFragment): SectionSearchSiteProps => ({
	heading: field_front_end_title,
	jumpLinksTitle: field_jump_links_title,
});
export const SectionSearchSite: React.FC<SectionSearchSiteProps> = ({
	heading,
	isHomepage,
	jumpLinksTitle,
}) => {
	const [searchTerm, setSearchTerm] = useState("");

	const searchUrl = useMemo(() => `/search?q=${searchTerm}`, [searchTerm]);

	return (
		<WrappedSection
			sectionName="SectionSearchSite"
			sectionColour={Colours.SANDY_FUR}
			isHomePage={isHomepage}
		>
			<div className={styles.sitesearchinner}>
				<div className={styles.searchinputwrapper}>
					<div className={styles.search}>
						{jumpLinksTitle ? (
							<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
								{heading}
							</h2>
						) : (
							<h2 className={styles.title}>{heading}</h2>
						)}
						<TextInput
							className={styles.searchinput}
							IconRight={Search}
							onIconRightCallback={() => navigate(searchUrl)}
							iconRightLabel="Search"
							iconRightDimensions={"28px"}
							onChange={(e) => setSearchTerm(e.currentTarget.value)}
							value={searchTerm}
							onEnterCallback={() => navigate(searchUrl)}
							name={""}
							placeholder={"Search all help topics"}
						/>
					</div>
					<img
						className={styles.dogimage}
						src={sniffingDogImage}
						alt={"sniffing dog icon"}
						width={387}
						height={125}
					/>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionSearchSite;
